import * as actions from 'actions/HelpCentreActions/issueFaqActions';
import { LOADING, INIT, SUCCESS, ERROR } from 'utils/asyncStatusHelper';
import get from 'lodash/get';
const { issueFaqActionsEnum } = actions;
const defaultState = {
    data: {},
    asyncStatus: INIT,
    selectedIssueFaq: null,
    parentIssue: null
};
export default function issueFaq(state = defaultState, action) {
    switch (action.type) {
        case issueFaqActionsEnum.SELECT_ISSUEFAQ:
            return Object.assign({}, state, {
                selectedIssueFaq: action.selectedIssueIndex
            });
        case issueFaqActionsEnum.ISSUEFAQ_REQUEST:
            return Object.assign({}, state, {
                asyncStatus: LOADING
            });
        case issueFaqActionsEnum.ISSUEFAQ_SUCCESS:
            return Object.assign({}, state, {
                data: action.data,
                asyncStatus: SUCCESS
            });
        case issueFaqActionsEnum.ISSUEFAQ_ERROR:
            return Object.assign({}, state, {
                asyncStatus: ERROR
            });
        case issueFaqActionsEnum.SELECT_PARENT_ISSUEFAQ:
            return Object.assign({}, state, {
                parentIssue: action.parentIssue
            });
        default:
            return state;
    }
}
export const getSelectedIssueFaq = (state = defaultState) => {
    const isResult = get(state, ['data', 'result']) && state.data.result.length;
    return (isResult &&
        state.data.result.filter((item, index) => state.selectedIssueFaq ? item.faqId === state.selectedIssueFaq : index === 0));
};
